(function ($) {



    const FORM_FIELD_ERROR_CLASS = 'field-error';


    function getResultMessageEl($formEl) {
        if (!$formEl || !$formEl.length) return;

        return $formEl.find('.newsletter-signup-form-res-message');
    }



    function setEmailFieldMessage($formEl, message) {
        if (!$formEl || !$formEl.length) return;

        const $emailMessageEl = $formEl.find('.newsletter-signup-form-email-msg');
        $emailMessageEl.text(message);

        if (message.trim() === '') {
            $emailMessageEl.hide();
            $formEl.find('[name="subscribe_email"]').removeClass( FORM_FIELD_ERROR_CLASS );
        }
        else {
            $emailMessageEl.show();
            $formEl.find('[name="subscribe_email"]').addClass( FORM_FIELD_ERROR_CLASS );
        }
    }



    function setConsentFieldMessage($formEl, message) {
        if (!$formEl || !$formEl.length) return;

        const $consentMessageEl = $formEl.find('.newsletter-signup-form-consent-msg');
        $consentMessageEl.text(message);

        if (message.trim() === '') {
            $consentMessageEl.hide();
            $formEl.find('[name="subscribe_consent"]').removeClass( FORM_FIELD_ERROR_CLASS );
        }
        else {
            $consentMessageEl.show();
            $formEl.find('[name="subscribe_consent"]').addClass( FORM_FIELD_ERROR_CLASS );
        }
    }



    function resetFormFields($formEl) {
        if (!$formEl || !$formEl.length) return;

        $formEl.get(0).reset(); // resetting fields values

        // resetting fields error messages
        setEmailFieldMessage($formEl, '');
        setConsentFieldMessage($formEl, '');
    }



    function hideResultMessage($formEl) {
        if (!$formEl || !$formEl.length) return;

        const $successMsgEl = getResultMessageEl($formEl);
        $successMsgEl.hide();

        resetResultMessage($successMsgEl);
    }


    function resetResultMessage($el) {
        if (!$el || !$el.length) return;

        $el.text('');
    }



    function toggleLoadingSpinner($formEl, toShow) {
        if (!$formEl || !$formEl.length) return;

        const $loadingSpinner = $formEl.find('.newsletter-signup-form-spinner');

        if (toShow) $loadingSpinner.show();
        else $loadingSpinner.hide();
    }


    function setFormSubmissionResultMessageText($formEl, text, isSuccess) {
        if (!$formEl || !$formEl.length) return;

        const $successMsgEl = getResultMessageEl($formEl);

        if (!$successMsgEl || !$successMsgEl.length) return;

        // fading out form-elements to show success message
        if (isSuccess) $formEl.addClass('newsletter-signup-form--success');
        else $formEl.addClass('newsletter-signup-form--fail');

        $successMsgEl.show().text(text);


        // setTimeout(function () {
        //     resetFormToDefaultState($formEl);
        // }, 4000);
    }




    function resetFormToDefaultState($formEl) {
        if (!$formEl || !$formEl.length) return;

        $formEl.removeClass('newsletter-signup-form--success newsletter-signup-form--fail');

        hideResultMessage($formEl);

        resetFormFields($formEl);
    }




    function checkIfNeedRedirect(res) {
        if (!res['data'])
            return;

        if (res['data']['download_url']) {
            window.location.href = res['data']['download_url'];
            return;
        }


        if (res.data['redirect_to']) {
            setTimeout(function() {
                // console.log(res.data['redirect_to'])
                window.location.replace(res.data['redirect_to']);
            }, 4000)
        }
    }



    $(document).on('ready', function () {


        $('.newsletter-signup-form [name="subscribe_email"]').on('input', function () {
            const $thisEmailField = $(this);

            if (!$thisEmailField.val().trim()) return;

            $thisEmailField.removeClass('field-error');

            setEmailFieldMessage($thisEmailField.closest('form'), '');
        });



        $('.newsletter-signup-form [name="subscribe_consent"]').on('change', function () {
            const $thisConsentField = $(this);

            if (!$thisConsentField.prop('checked')) return;

            $thisConsentField.removeClass('field-error');

            setConsentFieldMessage($thisConsentField.closest('form'), '');
        });



        $('.newsletter-signup-form').on('submit', function (e) {
            e.preventDefault();

            const $thisFormEl = $(this);

            const formData = new FormData($thisFormEl.get(0));

            hideResultMessage($thisFormEl);

            setEmailFieldMessage($thisFormEl, '');
            setConsentFieldMessage($thisFormEl, '');

            toggleLoadingSpinner($thisFormEl, true);

            $.ajax({
                url: ajax_object.ajax_url,
                method: 'POST',
                data: {
                    action: 'newsletter_signup',
                    nonce: ajax_object.nonce,
                    user_email: formData.get('subscribe_email'),
                    user_subscription_consent: formData.get('subscribe_consent'),
                    looker_studio_report_request: formData.get('looker_studio_report_request'),
                    attachment_id: formData.get('attachment_id'),
                    guide_file_download: formData.get('guide_file_download')
                }
            })
                .done(function (res) {

                    if (res.success) {
                        setFormSubmissionResultMessageText($thisFormEl, res.data['message'], true);
                        checkIfNeedRedirect(res);
                        return;
                    }

                    const errorCode = res.data['code'];

                    if (!errorCode) return;

                    switch (errorCode.toString()) {
                        case 'invalid_email': {
                            setEmailFieldMessage($thisFormEl, res.data['message'] || 'Something wrong with provided email');
                            break;
                        }
                        case 'invalid_consent': {
                            setConsentFieldMessage($thisFormEl, res.data['message'] || 'Permission to email has not been given');
                            break;
                        }
                        case 'newsletter_subscribe_request_failed': {
                            setFormSubmissionResultMessageText($thisFormEl, res.data['message'] || 'Something went wrong', false);
                            break;
                        }
                        case '403': {
                            setFormSubmissionResultMessageText($thisFormEl, res.data['message'] || 'Permission denied', false);
                            break;
                        }

                    }
                })
                .fail(function (xhr) {

                })
                .always(function () {
                    toggleLoadingSpinner($thisFormEl, false);
                });

        });

    });


})(jQuery);